import { formatLayoutVariantCount } from "entities/configurator/model/layoutChoiceName";
import { getLayoutBrowseGroup } from "entities/configurator/model/layoutMeta";
import React from "react";
import { OptionTemplate } from "shared/api/middleware-api-client";
import DoorOptionsIcon, { DoorOptionsType } from "shared/ui/door-options-icons";
import { Delimiter } from "widgets/business-configurator/door-options/Delimiter";
import { useLayoutSelector } from "widgets/configurator/door-options-controls/components/hooks/useLayoutSelector";

export const MobileDoorOptionsControlsList = React.memo(() => {
  const {
    sortedLayoutList,
    getLayoutSubchoiceCount,
    onChangeLayout,
    searchParams,
    getDisplayName,
  } = useLayoutSelector();
  const selectedCode = searchParams.get("layout");
  const selectedGroup = getLayoutBrowseGroup(selectedCode);

  const eigenwijsLayout = sortedLayoutList.find(
    (layout) => layout.code === "eigenwijs",
  );

  return (
    <>
      <div className="gg-grid gg-h-full gg-w-full gg-grid-cols-3 gg-place-items-center gg-items-start gg-gap-3 gg-gap-y-4">
        {sortedLayoutList.map((layout: OptionTemplate) => {
          if (layout.code === "eigenwijs") return null;

          const layoutName = getDisplayName(layout);
          const layoutGroup = getLayoutBrowseGroup(layout.code);
          const subchoiceCount = getLayoutSubchoiceCount(layout.code);
          const subchoiceLabel =
            subchoiceCount > 0
              ? formatLayoutVariantCount(subchoiceCount)
              : undefined;
          const accessibleName = subchoiceLabel
            ? `${layoutName}, ${subchoiceLabel}`
            : layoutName;
          const isSelectedGroup =
            layoutGroup !== null && layoutGroup === selectedGroup;
          const isActive = layout.code === selectedCode || isSelectedGroup;

          return (
            <button
              key={layout.code}
              type="button"
              className="gg-flex gg-max-w-min gg-flex-col gg-text-left"
              onClick={() => onChangeLayout(layout)}
              aria-label={accessibleName}
              data-layout-group={layoutGroup ?? undefined}
              data-testid={`door-layout-option-${layout.code}`}
            >
              <DoorOptionsIcon
                selectedDoor={layout.code as DoorOptionsType}
                isActive={isActive}
              />
              <span className="gg-w-16 gg-pt-1 gg-text-xs gg-font-semibold gg-leading-4 gg-tracking-wide gg-text-primary-color">
                {layoutName}
              </span>
              {subchoiceLabel && (
                <span className="gg-mt-1 gg-text-[11px] gg-leading-4 gg-text-secondary-text">
                  {subchoiceLabel}
                </span>
              )}
            </button>
          );
        })}

        {eigenwijsLayout && (
          <div className="gg-col-span-full gg-mt-1.5 gg-flex gg-justify-center">
            <button
              onClick={() => onChangeLayout(eigenwijsLayout)}
              data-testid={`door-layout-option-${eigenwijsLayout.code}`}
              className="gg-rounded-md gg-bg-dark-blue gg-px-3 gg-py-2.5 gg-text-xs gg-font-semibold gg-text-white hover:gg-bg-dark-blue/70"
            >
              Ontwerp je eigen deur
            </button>
          </div>
        )}
        <Delimiter className="gg-col-span-full" />
      </div>
    </>
  );
});
